import { render } from "./BaseOverlay.vue?vue&type=template&id=0745fe57&scoped=true"
import script from "./BaseOverlay.vue?vue&type=script&lang=js"
export * from "./BaseOverlay.vue?vue&type=script&lang=js"

import "./BaseOverlay.vue?vue&type=style&index=0&id=0745fe57&scoped=true&lang=scss"

import exportComponent from "/Users/petertoh/Sites/martin-keehn/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0745fe57"]])

export default __exports__